// @flow
import React from 'react';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import * as selectors from '../../../reducers';
import User from '../../User';

import styles from './weekheader.css';
import { getUserImage } from '../../../utils';


type WeekHeaderPropTypes = {
  title: string,
  pictureURL: string,
};

const WeekHeader = ({
  title,
  pictureURL,
}: WeekHeaderPropTypes) => (
  <tr className={styles.weekHeader}>
    <td>
      <User
        firstName={title}
        size="large"
        userRole={i18n.t('labels.students', { count: 1 })}
        pictureURL={pictureURL}
        clearMargins
      />
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.mon')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.tues')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.wed')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.thurs')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.fri')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.sat')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.sun')}
    </td>
  </tr>
);


export default connect(
  (state, { studentId }) => {
    const student = selectors.getStudent(state, studentId);

    return {
      title: `${student.first_name} ${student.last_name}`,
      pictureURL: getUserImage(student.profile_picture),
    };
  },
  undefined,
)(WeekHeader);



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulingPopup/WeekHeader/index.jsx